import React from 'react';
import PropTypes from 'prop-types';
import { getListItemShape, PROP_ADDRESS, PROP_ID } from 'redux/models/offices/model';
import Button from 'theme/components/Button/Button';
import { MarkerIcon } from 'theme/components/Icons/Icons';
import Styles from './OfficePageList.scss';

const OfficePageListItem = ({ selectedOffice, city, offices, chooseOffice }) => (
  <div className={Styles.listItem}>
    <strong className={Styles.listItemCaption}>
      {city}
    </strong>
    {offices.map((office) => {
      const isOfficeChosen = selectedOffice === office[PROP_ID];
      return (
        <div className={Styles.listItemContent} key={office[PROP_ID]}>
          <div className={Styles.listItemContentBase}>
            <MarkerIcon className={Styles.listItemContentIcon} />
            <p className={Styles.listItemContentText}>{office[PROP_ADDRESS]}</p>
          </div>
          <div className={Styles.listItemBtn}>
            <Button onClick={() => chooseOffice(office)} isActive={isOfficeChosen}>
              {isOfficeChosen ? 'Выбран' : 'Выбрать'}
            </Button>
          </div>
        </div>
      );
    })}
  </div>
);

OfficePageListItem.propTypes = {
  selectedOffice: PropTypes.number,
  city: PropTypes.string,
  offices: PropTypes.arrayOf(getListItemShape()),
  chooseOffice: PropTypes.func
};

export default OfficePageListItem;
